import React from 'react';

import PropTypes from 'prop-types';
import { Box, StackView, Typography } from '@telus-uds/components-web';

import {
  Thead,
  Td,
  Tr,
  Th
} from '../orderDetailsSection/ratePlans/components/css';
import getFormattedPricing from '../orderDetailsSection/utils';

const SummaryInstallServices = ({ installServices, total, isGeotabProduct }) => {
  // Filter out zero-qty entries at render time. Raw map is still
  // persisted to BE (partial-merge save needs explicit qty:0 to clear
  // previously-saved entries); the in-app summary should only show
  // services the customer actually selected.
  const visibleServices = Object.keys(installServices).filter(
    item => installServices[item] && Number(installServices[item].quantity) > 0
  );
  if (visibleServices.length === 0) return null;

  const getQuantity = (serviceName, quantity) => {
    if (serviceName !== 'Travel Fee') return quantity;
    return Math.ceil(quantity / 10);
  };
  return (
    <>
      {Object.keys(installServices).length > 0 && (
        <StackView space={3}>
          <Typography heading="h4" variant={{ size: 'h4' }} block>{isGeotabProduct ? 'Installation Services' : 'Install Services'}</Typography>
          <table>
            <Thead>
              <Tr>
                <Th>Install Service</Th>
                <Th>Unit</Th>
                <Th>Unit Price</Th>
                <Th>Total</Th>
              </Tr>
            </Thead>
            <tbody>
              {visibleServices
                .reverse()
                .map(serviceName => {
                  const { quantity, unitPrice } = installServices[serviceName];
                  return (
                    <tr>
                      <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
                        {serviceName}
                      </Td>
                      <Td>{quantity}</Td>
                      <Td>{getFormattedPricing(unitPrice)}</Td>
                      <Td>
                        {getFormattedPricing(
                          unitPrice * getQuantity(serviceName, quantity)
                        )}
                      </Td>
                    </tr>
                  );
                })}
              <Tr style={{ background: '#f4f4f4' }}>
                <Td colSpan={3}>
                  <Typography variant={{ bold: true }}>Total</Typography>
                </Td>
                <Td>
                  <Typography variant={{ bold: true }}>{getFormattedPricing(total)}</Typography>
                </Td>
              </Tr>
            </tbody>
          </table>
        </StackView>
      )}
    </>
  );
};

SummaryInstallServices.propTypes = {
  installServices: PropTypes.shape({
    quantity: PropTypes.number,
    unitPrice: PropTypes.number
  }).isRequired,
  total: PropTypes.number.isRequired,
  isGeotabProduct: PropTypes.bool.isRequired
};

export default SummaryInstallServices;
